/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import React from 'react';
import { CSSTransition } from 'react-transition-group';
import { sdsTransitionDefaults, SdsTransitionProps } from './SdsTransition.props';

/**
 * SDS Transition component.
 */
export const SdsTransition = (props: SdsTransitionProps): JSX.Element => {
  const { children, exitCallback, isActive, timeout, transitionType } = {
    ...sdsTransitionDefaults,
    ...props,
  };

  const transitionTypeClass = `sds-transition--${transitionType}`;
  const transitionClass = transitionType ? `${transitionTypeClass} sds-transition-${transitionType}` : `sds-transition`;

  const closeHandler = (): void => {
    exitCallback();
  };

  return (
    <CSSTransition classNames={transitionClass} in={isActive} onExited={closeHandler} timeout={timeout}>
      {transitionType ? <div className={transitionTypeClass}>{children}</div> : <>{children}</>}
    </CSSTransition>
  );
};
